import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
import { RecoveryDataNamespace } from "./recovery/data.js";
import { RecoverySharedNamespace } from "./recovery/shared.js";
class RecoveryNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the _bindMissingCustomerToMessage global action. */
    this._bindMissingCustomerToMessage = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "_bindMissingCustomerToMessage",
      operationName: "_bindMissingCustomerToMessage",
      operationReturnType: "RecoveryBindMissingCustomerToMessage",
      namespace: "recovery",
      variables: {}
    });
    /** Executes the _bindShopifyOrderToMessage global action. */
    this._bindShopifyOrderToMessage = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "_bindShopifyOrderToMessage",
      operationName: "_bindShopifyOrderToMessage",
      operationReturnType: "RecoveryBindShopifyOrderToMessage",
      namespace: "recovery",
      variables: { cursor: { required: false, type: "String" } }
    });
    /** Executes the _getMessagesAnalyticsByCustomer global action. */
    this._getMessagesAnalyticsByCustomer = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "_getMessagesAnalyticsByCustomer",
      operationName: "_getMessagesAnalyticsByCustomer",
      operationReturnType: "RecoveryGetMessagesAnalyticsByCustomer",
      namespace: "recovery",
      variables: {
        customerId: { required: false, type: "String" },
        fromDate: { required: false, type: "String" }
      }
    });
    /** Executes the _getMissingCustomerToMessageReport global action. */
    this._getMissingCustomerToMessageReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "_getMissingCustomerToMessageReport",
      operationName: "_getMissingCustomerToMessageReport",
      operationReturnType: "RecoveryGetMissingCustomerToMessageReport",
      namespace: "recovery",
      variables: {
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the cleanCsvImport global action. */
    this.cleanCsvImport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "cleanCsvImport",
      operationName: "cleanCsvImport",
      operationReturnType: "RecoveryCleanCsvImport",
      namespace: "recovery",
      variables: {}
    });
    /** Executes the contactDetach1040 global action. */
    this.contactDetach1040 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "contactDetach1040",
      operationName: "contactDetach1040",
      operationReturnType: "RecoveryContactDetach1040",
      namespace: "recovery",
      variables: {
        limit: { required: false, type: "Float" },
        execute: { required: false, type: "Boolean" },
        customerId: { required: false, type: "String" },
        traceId: { required: false, type: "String" },
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" }
      }
    });
    /** Executes the contactDetach1316 global action. */
    this.contactDetach1316 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "contactDetach1316",
      operationName: "contactDetach1316",
      operationReturnType: "RecoveryContactDetach1316",
      namespace: "recovery",
      variables: {
        limit: { required: false, type: "Float" },
        execute: { required: false, type: "Boolean" },
        customerId: { required: false, type: "String" },
        traceId: { required: false, type: "String" }
      }
    });
    /** Executes the contactDetach1362 global action. */
    this.contactDetach1362 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "contactDetach1362",
      operationName: "contactDetach1362",
      operationReturnType: "RecoveryContactDetach1362",
      namespace: "recovery",
      variables: { limit: { required: false, type: "Float" } }
    });
    /** Executes the contactDetach1529 global action. */
    this.contactDetach1529 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "contactDetach1529",
      operationName: "contactDetach1529",
      operationReturnType: "RecoveryContactDetach1529",
      namespace: "recovery",
      variables: { limit: { required: false, type: "Float" } }
    });
    /** Executes the contactReHash1040 global action. */
    this.contactReHash1040 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "contactReHash1040",
      operationName: "contactReHash1040",
      operationReturnType: "RecoveryContactReHash1040",
      namespace: "recovery",
      variables: {
        execute: { required: false, type: "Boolean" },
        customerId: { required: false, type: "String" },
        limit: { required: false, type: "Float" }
      }
    });
    /** Executes the copyHashToExternalId global action. */
    this.copyHashToExternalId = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "copyHashToExternalId",
      operationName: "copyHashToExternalId",
      operationReturnType: "RecoveryCopyHashToExternalId",
      namespace: "recovery",
      variables: {
        execute: { required: false, type: "Boolean" },
        customerId: { required: false, type: "String" },
        limit: { required: false, type: "Float" }
      }
    });
    /** Executes the decryptContacts160chars global action. */
    this.decryptContacts160chars = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "decryptContacts160chars",
      operationName: "decryptContacts160chars",
      operationReturnType: "RecoveryDecryptContacts160chars",
      namespace: "recovery",
      variables: {
        limit: { required: false, type: "Float" },
        execute: { required: false, type: "Boolean" },
        customerId: { required: false, type: "String" }
      }
    });
    /** Executes the deduplicateSamsungContactsByTag global action. */
    this.deduplicateSamsungContactsByTag = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "deduplicateSamsungContactsByTag",
      operationName: "deduplicateSamsungContactsByTag",
      operationReturnType: "RecoveryDeduplicateSamsungContactsByTag",
      namespace: "recovery",
      variables: {
        tagId: { required: false, type: "String" },
        execute: { required: false, type: "String" }
      }
    });
    /** Executes the detachContacts32chars global action. */
    this.detachContacts32chars = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "detachContacts32chars",
      operationName: "detachContacts32chars",
      operationReturnType: "RecoveryDetachContacts32chars",
      namespace: "recovery",
      variables: {
        batchSize: { required: false, type: "Float" },
        execute: { required: false, type: "Boolean" },
        customerId: { required: false, type: "String" }
      }
    });
    /** Executes the exportSamsungDailySendingsWithHistoric global action. */
    this.exportSamsungDailySendingsWithHistoric = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "exportSamsungDailySendingsWithHistoric",
      operationName: "exportSamsungDailySendingsWithHistoric",
      operationReturnType: "RecoveryExportSamsungDailySendingsWithHistoric",
      namespace: "recovery",
      variables: {
        campaignIds: { required: false, type: "[String!]" },
        customerId: { required: false, type: "String" },
        uploadToBucket: { required: false, type: "Boolean" },
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" }
      }
    });
    /** Executes the getContactWithExpiredCustomCouponCodes global action. */
    this.getContactWithExpiredCustomCouponCodes = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getContactWithExpiredCustomCouponCodes",
      operationName: "getContactWithExpiredCustomCouponCodes",
      operationReturnType: "RecoveryGetContactWithExpiredCustomCouponCodes",
      namespace: "recovery",
      variables: {
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the getMissingAttributedShopifyOrderOnMessageReport global action. */
    this.getMissingAttributedShopifyOrderOnMessageReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getMissingAttributedShopifyOrderOnMessageReport",
      operationName: "getMissingAttributedShopifyOrderOnMessageReport",
      operationReturnType: "RecoveryGetMissingAttributedShopifyOrderOnMessageReport",
      namespace: "recovery",
      variables: {
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the getMissingCustomerToMessageReport251205 global action. */
    this.getMissingCustomerToMessageReport251205 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getMissingCustomerToMessageReport251205",
      operationName: "getMissingCustomerToMessageReport251205",
      operationReturnType: "RecoveryGetMissingCustomerToMessageReport251205",
      namespace: "recovery",
      variables: {
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes the initializeUserCustomer global action. */
    this.initializeUserCustomer = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "initializeUserCustomer",
      operationName: "initializeUserCustomer",
      operationReturnType: "RecoveryInitializeUserCustomer",
      namespace: "recovery",
      variables: { readonly: { required: false, type: "Boolean" } }
    });
    /** Executes the migrateContactsByHashedPhone global action. */
    this.migrateContactsByHashedPhone = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "migrateContactsByHashedPhone",
      operationName: "migrateContactsByHashedPhone",
      operationReturnType: "RecoveryMigrateContactsByHashedPhone",
      namespace: "recovery",
      variables: {
        hashedPhoneNumber: { required: false, type: "String" },
        customerId: { required: false, type: "String" },
        traceId: { required: false, type: "String" }
      }
    });
    /** Executes the orchestrateMigrateOldEncryption global action. */
    this.orchestrateMigrateOldEncryption = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "orchestrateMigrateOldEncryption",
      operationName: "orchestrateMigrateOldEncryption",
      operationReturnType: "RecoveryOrchestrateMigrateOldEncryption",
      namespace: "recovery",
      variables: {
        customerId: { required: false, type: "String" },
        limit: { required: false, type: "String" }
      }
    });
    /** Executes the processContactReHashBatch global action. */
    this.processContactReHashBatch = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processContactReHashBatch",
      operationName: "processContactReHashBatch",
      operationReturnType: "RecoveryProcessContactReHashBatch",
      namespace: "recovery",
      variables: {
        customerId: { required: false, type: "String" },
        processId: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        batchNumber: { required: false, type: "String" },
        contactIds: { required: false, type: "String" }
      }
    });
    /** Executes the processCopyHashToExternalIdBatch global action. */
    this.processCopyHashToExternalIdBatch = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "processCopyHashToExternalIdBatch",
      operationName: "processCopyHashToExternalIdBatch",
      operationReturnType: "RecoveryProcessCopyHashToExternalIdBatch",
      namespace: "recovery",
      variables: {
        customerId: { required: false, type: "String" },
        processId: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        batchNumber: { required: false, type: "String" },
        contactIds: { required: false, type: "String" }
      }
    });
    /** Executes the rattachContacts32chars global action. */
    this.rattachContacts32chars = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "rattachContacts32chars",
      operationName: "rattachContacts32chars",
      operationReturnType: "RecoveryRattachContacts32chars",
      namespace: "recovery",
      variables: {
        batchSize: { required: false, type: "Float" },
        execute: { required: false, type: "Boolean" },
        customerId: { required: false, type: "String" }
      }
    });
    /** Executes the rattrapageShopifyOrdersAttributionReport global action. */
    this.rattrapageShopifyOrdersAttributionReport = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "rattrapageShopifyOrdersAttributionReport",
      operationName: "rattrapageShopifyOrdersAttributionReport",
      operationReturnType: "RecoveryRattrapageShopifyOrdersAttributionReport",
      namespace: "recovery",
      variables: {
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" },
        customerId: { required: false, type: "String" },
        processId: { required: false, type: "String" },
        cursor: { required: false, type: "String" },
        itemsProcessed: { required: false, type: "String" },
        data: { required: false, type: "String" },
        iteration: { required: false, type: "String" },
        maxIteration: { required: false, type: "String" },
        execute: { required: false, type: "String" },
        startedAt: { required: false, type: "String" }
      }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "recovery",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
    this.data = new RecoveryDataNamespace(this);
    this.shared = new RecoverySharedNamespace(this);
  }
}
export {
  RecoveryNamespace
};
//# sourceMappingURL=recovery.js.map
